import { AnyAction } from 'redux'
import { produce } from 'immer'
import { PaginateWithTypeRequest, PaginateResponse } from '../../services/api.service'
import customLabelService from '../../services/customLabel.service'
import { CustomLabelData } from '../../apis/customLabel.api'

interface State extends PaginateWithTypeRequest {
    result: PaginateResponse<CustomLabelData[]>
    search: string
    sortBy: string
    isSearchFallback: boolean
}

const initialState: State = {
  result: {
    data: [],
    total: 0,
    from: null,
    to: null,
    currentPage: 0,
    lastPage: 0
  },
  page: 1,
  limit: 25,
  search: '',
  labelableType: '',
  sortBy: 'desc',
  isSearchFallback: false

}

export const actions = {
  replaceResult: 'systemLabels/replaceResult',
  replaceResultData: 'systemLabels/replaceResultData',
  replacePage: 'systemLabels/replacePage',
  replaceLimit: 'systemLabels/replaceLimit',
  replaceSearch: 'systemLabels/replaceSearch',
  replaceLabelableType: 'systemLabels/replaceLabelableType',
  replaceSorting: 'systemLabels/replaceSorting',
  replaceSearchFallback: 'systemLabels/replaceSearchFallback'
}

export function replaceResult (result: State['result']) {
  return { type: actions.replaceResult, result }
}

export function replaceResultData (data: State['result']['data']) {
  return { type: actions.replaceResultData, data }
}

export function replacePage (page: number) {
  return { type: actions.replacePage, page }
}

export function replaceLabelableType (labelableType: string) {
  return { type: actions.replaceLabelableType, labelableType }
}

export function replaceLimit (limit: number) {
  return { type: actions.replaceLimit, limit }
}

export function replaceSearch (search: string) {
  return { type: actions.replaceSearch, search }
}

export function replaceSorting (sortBy: string) {
  return { type: actions.replaceSorting, sortBy }
}

export function replaceSearchFallback (isSearchFallback: boolean) {
  return { type: actions.replaceSearchFallback, isSearchFallback }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.replaceResult:
      return produce(state, draft => {
        draft.result = action.result
        draft.result.data = customLabelService.tableHorizontalData(action.result.data)
      })
    case actions.replaceResultData:
      return produce(state, draft => {
        draft.result.data = action.data
      })
    case actions.replacePage:
      return produce(state, draft => {
        draft.page = action.page
      })
    case actions.replaceLimit:
      return produce(state, draft => {
        draft.limit = action.limit
      })
    case actions.replaceSearch:
      return produce(state, draft => {
        draft.search = action.search
        draft.page = 1
      })
    case actions.replaceLabelableType:
      return produce(state, draft => {
        draft.labelableType = action.labelableType
        draft.page = 1
      })
    case actions.replaceSorting:
      return produce(state, draft => {
        draft.sortBy = action.sortBy
      })
    case actions.replaceSearchFallback:
      return produce(state, draft => {
        draft.isSearchFallback = action.isSearchFallback
      })
    default:
      return state
  }
}
